import React from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import MessageError from 'Components/Common/MessageError';
import { labelRequire } from 'Components/Common/Form/FormLabel';
import HintTextField from 'Components/Common/Form/HintTextField';
import BRTimePicker, {
  BRDatePickerTypes,
  BRDate,
} from 'Components/Common/NewDatePicker/TimePicker';
import { ColSpec } from 'Components/Common/Form/form';

interface FormGroupDateProps extends Omit<BRDatePickerTypes, 'onChangeDate'> {
  label?: string;
  labelAfter?: string;
  subLabel?: string;
  classForm?: string;
  colClass?: string;
  labelMd: ColSpec;
  colMd: ColSpec;
  onChange: (date: BRDate) => void;
  selected: BRDate;
  colDP?: ColSpec;
  subContent?: string;
  classCol?: string;
  errorMessage?: string;
  hintText?: string;
  showTime?: boolean;
}

const BRFormGroupTime = ({
  label,
  labelAfter,
  labelMd,
  colMd,
  classForm,
  onChange,
  classCol,
  errorMessage,
  selected,
  minDate,
  maxDate,
  disabled = false,
  placeholder,
  dateFormat,
  colDP = 12,
  subContent,
  hintText = '',
  showTime = true,
  currentDate,
}: FormGroupDateProps): JSX.Element => {
  return (
    <Form.Group as={Row} className={`mb-3 ${classForm || ''}`}>
      <Form.Label column md={labelMd}>
        {label && labelRequire(label)}
        <p>{labelAfter}</p>
      </Form.Label>
      <Col md={colMd} className={`${classCol} ${labelAfter && 'mt-2'}`}>
        <Row>
          <Col md={colDP} className="px-0">
            <BRTimePicker
              dateFormat={dateFormat}
              timeFormat="HH:mm"
              placeholder={placeholder}
              currentDate={currentDate}
              selected={selected}
              onChangeDate={onChange}
              minDate={minDate ? minDate : new Date()}
              maxDate={maxDate}
              disabled={disabled}
              showTimeSelect={showTime}
            />
            {subContent && <p className="fs-12 mt-1">{subContent}</p>}
          </Col>
          <HintTextField hintText={hintText} />
          <MessageError classWrapper="ms-2 px-0" message={errorMessage} />
        </Row>
      </Col>
    </Form.Group>
  );
};

export default BRFormGroupTime;
